module.exports = __webpack_public_path__ + "static/media/img-ceo.213dbd90.png";